import { batch } from "react-redux";
import { requestAsync } from "redux-query";
import { appInsightEvents, language } from "language/default";
import { appInsightsTrackEvent } from "plugins/app-insight-init";
import { setIsStriped, removeAllSelectedRow } from "store/grids";
import { getCurrentLocalTime } from "common/date-utils";
export const getDataMenu = (options) => {
    const menuItems = [];
    if (options.excelExportDatapointsRequestQueryConfig?.body && !options.suppressExcelExport) {
        menuItems.push({
            action: () => {
                options.dispatch(requestAsync(options.excelExportDatapointsRequestQueryConfig));
                appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.WidgetGridExportToExcel, properties: { LocalTimestamp: getCurrentLocalTime() } });
            },
            hasEmptyIcon: true,
            key: "download-excel",
            label: language.en.grid.excelExport.downloadExcel,
            leftIcon: "export"
        });
        menuItems.unshift({
            action: options.openPDFDownloadModal,
            hasEmptyIcon: true,
            key: "download-pdf",
            label: language.en.dashboard.pdfExport.downloadPdf,
            leftIcon: "export"
        });
    }
    const refreshMenuItem = {
        action: () => {
            options.refreshAction && options.refreshAction();
            options.dispatch(removeAllSelectedRow(options.stateId));
        },
        hasBottomBorder: true,
        hasEmptyIcon: true,
        key: "refresh",
        label: language.en.common.refresh
    };
    menuItems.push(refreshMenuItem);
    const rowStripingMenuItem = {
        action: () => batch(() => {
            options.dispatch(setIsStriped({ id: options.stateId, isStriped: !options.isZebra }));
            options.dispatch(removeAllSelectedRow(options.stateId));
        }),
        hasEmptyIcon: true,
        isSelected: options.isZebra,
        key: "rowStriping",
        label: language.en.common.rowStriping
    };
    if (!options.userSettings?.hideRowStriping) {
        menuItems.push(rowStripingMenuItem);
    }
    return [menuItems];
};
export const getExportMenu = (options) => {
    const menuItems = [];
    if (options.fundWidget) {
        menuItems.push({
            action: options.openPDFDownloadModal,
            hasEmptyIcon: true,
            key: "download-pdf",
            label: language.en.dashboard.pdfExport.downloadPdf,
            leftIcon: "export"
        });
    }
    if (options.suppressExcelExport === false || options.useClientExcelExport) {
        menuItems.push({
            action: () => {
                options.ref?.current?.exportExcel();
                appInsightsTrackEvent({ name: appInsightEvents.customEvents.names.WidgetGridExportToExcel, properties: { LocalTimestamp: getCurrentLocalTime() } });
            },
            hasEmptyIcon: true,
            key: "download-excel",
            label: language.en.grid.excelExport.downloadExcel,
            leftIcon: "export"
        });
        menuItems.unshift({
            action: options.openPDFDownloadModal,
            hasEmptyIcon: true,
            key: "download-pdf",
            label: language.en.dashboard.pdfExport.downloadPdf,
            leftIcon: "export"
        });
    }
    return [menuItems];
};
